var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      staticClass: "svg-magnifier",
      attrs: {
        width: "13px",
        height: "13px",
        viewBox: "0 0 13 13",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                transform: "translate(-807.000000, -53.000000)",
                stroke: "#ED342E",
                "stroke-width": "2"
              }
            },
            [
              _c(
                "g",
                { attrs: { transform: "translate(807.000000, 53.000000)" } },
                [
                  _c("circle", {
                    attrs: { fill: "#FFFFFF", cx: "5", cy: "5", r: "4" }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: { d: "M9,9 L11,11", "stroke-linecap": "square" }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }